import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Découvrez toutes les offres de nos partenaires sélectionnés pour vous accompagner dans votre vie d’entreprise et personnelle.',
    fetchMore: 'Voir plus',
    title: 'Offres',
  },
  fr: {
    description:
      'Découvrez toutes les offres de nos partenaires sélectionnés pour vous accompagner dans votre vie d’entreprise et personnelle.',
    fetchMore: 'Voir plus',
    title: 'Offres',
  },
});

export default locales;
